import React from 'react';
import { StyleSheet, View } from 'react-native';
import AccountCardSquare, {
  AccountCardSquareProps,
} from 'shared/components/vxl/cards/AccountCardSquare/AccountCardSquare';
import theme from 'shared/styles/theme';

export interface SideBySideCardGroupProps {
  cards: AccountCardSquareProps[];
}

const SideBySideCardGroup = ({ cards }: SideBySideCardGroupProps) => {
  const [lhs, rhs] = cards;

  if (!lhs) {
    return null;
  }

  return (
    <View style={styles.container} testID="side-by-side-card-group">
      <View style={styles.cardSlot}>
        {lhs ? <AccountCardSquare {...lhs} /> : null}
      </View>
      <View style={styles.cardSlot}>
        {rhs ? <AccountCardSquare {...rhs} /> : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  cardSlot: {
    alignContent: 'stretch',
    alignItems: 'stretch',
    flex: 1,
    flexDirection: 'row',
  },
  container: {
    alignItems: 'stretch',
    flexDirection: 'row',
    gap: theme.spacing.s,
    width: '100%',
  },
});

export default SideBySideCardGroup;
